

import React from 'react';
import { Header, Modal } from 'semantic-ui-react'
import SessionDetails from '../shared/SessionDetails'

class SessionDetailsModal extends React.Component {

  render() {
    return (
        <Modal
            open={this.props.modalOpen}
            onClose={this.props.handleClose}
            size='large'
            closeIcon
        >
            <Header content={this.props.modalTitle} />
            <Modal.Content>
                <SessionDetails key="details" sessionDetails={this.props.session} />
            </Modal.Content>
        </Modal>
    )
  }
}

export default SessionDetailsModal;
